/**
 * Get author name with fallback priority:
 * 1. display_name from profile
 * 2. first_name + last_name from members table
 * 3. author_name
 * 4. Anonymous
 */
export const getAuthorName = (item) => {
  // Priority 1: display_name from profile
  if (item.display_name && item.display_name.trim()) {
    return item.display_name;
  }
  // Priority 2: first_name + last_name from members table
  if (item.first_name && item.last_name) {
    return `${item.first_name} ${item.last_name}`;
  }
  // Priority 3: author_name
  return item.author_name || 'Anonymous';
};
